import { SessionStorage as BrowserSessionStorage } from '@vedicium/browser-storage';

export const SessionStorage = BrowserSessionStorage();
